"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _style = require("./style");
var _env = _interopRequireDefault(require("../../../helpers/env"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var URLs = {
  prod: 'wss://chatmercurio.olx.com.br/websocket',
  local: 'ws://localhost:5280/websocket'
};

// Creates inputs and states by name
function useInput(options) {
  var _options$type = options.type,
    type = _options$type === void 0 ? 'text' : _options$type,
    _options$currentValue = options.currentValue,
    currentValue = _options$currentValue === void 0 ? '' : _options$currentValue,
    _options$style = options.style,
    style = _options$style === void 0 ? {
      width: '80%'
    } : _options$style;
  var _useState = (0, _react.useState)(currentValue),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var input = /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
    style: style,
    value: value,
    onChange: function onChange(e) {
      return setValue(e.target.value);
    },
    type: type
  });
  return [value, input, setValue];
}
function DevControlPanel() {
  var _useState3 = (0, _react.useState)(true),
    _useState4 = _slicedToArray(_useState3, 2),
    folded = _useState4[0],
    setFolded = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    pendingChanges = _useState6[0],
    setPendingChanges = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isDefaultValues = _useState8[0],
    setIsDefaultValues = _useState8[1];
  var _useInput = useInput({
      type: 'text',
      currentValue: _env["default"].getAuthType()
    }),
    _useInput2 = _slicedToArray(_useInput, 2),
    localAuthType = _useInput2[0],
    AuthTypeInput = _useInput2[1];
  var _useInput3 = useInput({
      type: 'text',
      currentValue: _env["default"].getMercurioBaseUrl()
    }),
    _useInput4 = _slicedToArray(_useInput3, 3),
    localMercurioBaseUrl = _useInput4[0],
    MercurioBaseUrlInput = _useInput4[1],
    setMercurioUrl = _useInput4[2];
  var _useInput5 = useInput({
      type: 'text',
      currentValue: _env["default"].getSellerId()
    }),
    _useInput6 = _slicedToArray(_useInput5, 3),
    localSellerId = _useInput6[0],
    SellerIdInput = _useInput6[1],
    setSellerId = _useInput6[2];
  var _useInput7 = useInput({
      type: 'text',
      currentValue: _env["default"].getBuyerId()
    }),
    _useInput8 = _slicedToArray(_useInput7, 3),
    localBuyerId = _useInput8[0],
    BuyerIdInput = _useInput8[1],
    setBuyerId = _useInput8[2];
  var _useInput9 = useInput({
      type: 'text',
      currentValue: _env["default"].getListId()
    }),
    _useInput10 = _slicedToArray(_useInput9, 2),
    localListId = _useInput10[0],
    ListIdInput = _useInput10[1];
  var refs = {
    AuthType: localAuthType,
    MercurioBaseUrl: localMercurioBaseUrl,
    SellerId: localSellerId,
    BuyerId: localBuyerId,
    ListId: localListId
  };
  var swapUserIds = function swapUserIds() {
    var s = localSellerId;
    var b = localBuyerId;
    setSellerId(b);
    setBuyerId(s);
  };
  var updateEnv = function updateEnv() {
    _env["default"].OVERRIDABLE_KEYS.forEach(function (key) {
      _env["default"].setOverride(key, refs[key]);
    });
    window.location.reload();
  };
  var resetEnv = function resetEnv() {
    _env["default"].resetOverrides();
    window.location.reload();
  };
  var getColor = function getColor() {
    if (pendingChanges) {
      return 'coral';
    }
    if (isDefaultValues) {
      return 'palegreen';
    }
    return 'plum';
  };
  var isCurrentNonDefault = function isCurrentNonDefault() {
    return _env["default"].OVERRIDABLE_KEYS.some(function (configName) {
      return _env["default"]["get".concat(configName)]() !== _env["default"]["getDefault".concat(configName)]();
    });
  };

  // Initializes if using default values or not
  (0, _react.useEffect)(function () {
    setIsDefaultValues(!isCurrentNonDefault());
  });

  // Tracking pending changes
  (0, _react.useEffect)(function () {
    var didChange = _env["default"].OVERRIDABLE_KEYS.some(function (key) {
      return refs[key] !== _env["default"]["get".concat(key)]();
    });
    setPendingChanges(didChange);
  }, Object.values(refs));
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.Wrapper, {
    style: {
      backgroundColor: getColor()
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        cursor: 'pointer'
      },
      role: "presentation",
      onClick: function onClick() {
        setFolded(!folded);
      },
      children: ["Chat: ", /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
        children: "production"
      })]
    }), !folded && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("dl", {
        style: {
          display: 'flex',
          flexWrap: 'wrap',
          padding: '0.5em'
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("dt", {
          style: {
            width: '30%'
          },
          children: ["AuthType (", /*#__PURE__*/(0, _jsxRuntime.jsx)("code", {
            children: "mercurio"
          }), "|", /*#__PURE__*/(0, _jsxRuntime.jsx)("code", {
            children: "kong"
          }), ")"]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("dd", {
          style: {
            width: '60%'
          },
          children: AuthTypeInput
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("dt", {
          style: {
            width: '30%'
          },
          children: "Mercurio Url"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("dd", {
          style: {
            width: '60%'
          },
          children: [MercurioBaseUrlInput, /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)("ul", {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
              style: {
                cursor: 'pointer'
              },
              role: "presentation",
              onClick: function onClick() {
                return setMercurioUrl(URLs.prod);
              },
              children: ["prod:", URLs.prod, "\uD83D\uDD17"]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
              style: {
                cursor: 'pointer'
              },
              role: "presentation",
              onClick: function onClick() {
                return setMercurioUrl(URLs.local);
              },
              children: ["local:", URLs.local, "\uD83D\uDD17"]
            })]
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("dt", {
          style: {
            width: '30%'
          },
          children: "ListId "
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("dd", {
          style: {
            width: '60%'
          },
          children: ListIdInput
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("dt", {
          style: {
            width: '30%'
          },
          children: "SellerId"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("dd", {
          style: {
            width: '60%'
          },
          children: SellerIdInput
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("dt", {
          style: {
            width: '30%'
          },
          children: "BuyerId "
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("dd", {
          style: {
            width: '60%'
          },
          children: [BuyerIdInput, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            role: "presentation",
            onClick: swapUserIds,
            style: {
              cursor: 'pointer'
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              role: "img",
              "aria-label": "inverter",
              children: "\uD83D\uDD00"
            })
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          paddingBottom: '10px'
        },
        children: [pendingChanges && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          onClick: updateEnv,
          children: " Update "
        }), isDefaultValues || /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          onClick: resetEnv,
          children: " Reset "
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("hr", {
        style: {
          border: '1px solid'
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("em", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("small", {
          children: "by Messaging team @ chat-components-web"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {})]
    })]
  });
}
DevControlPanel.propTypes = {};
var _default = exports["default"] = DevControlPanel;